import { rwgLanguages } from 'constants/lang'

export const setRwgLocalstorage = (store_name, rwg_rending_type) => {
  // 예약 정보 삭제
  localStorage.removeItem('rwg_information')

  // 상점 이름 새로 저장
  localStorage.setItem('rwg_store_name', store_name)

  // RWG 타입 새로 저장
  localStorage.setItem('rwg_render_type', rwg_rending_type)
}

export const rwgInfoChangeTable = (data) => {
  if (!data) return null

  const splitData = data.split('\n')
  const replace = splitData.map((item) => item.replace('- ', ''))

  const value = replace.map((item, index) => {
    if (index !== replace.length - 1) {
      const regex = /[:：]/ // 반각 콜론(:) 또는 전체 자 콜론(：)
      const match = item.match(regex)
      const index = match ? match.index : -1

      return [item.slice(0, index).trim(), item.slice(index + 1).trim()]
    } else {
      return item
    }
  })

  return (
    <>
      <table style={{ borderCollapse: 'collapse' }}>
        <tbody>
          {value.map(
            (item, index) =>
              index !== value.length - 1 && // 마지막 데이터는 표 밖의 메세지임
              index !== 5 && // 5 : 여권번호
              index !== 12 && // 12, 13 : SNS
              index !== 13 && (
                <tr key={index}>
                  <th
                    style={{
                      border: '1px solid black',
                      padding: '4px 8px',
                      fontWeight: 400,
                    }}
                  >
                    {item[0]}
                  </th>
                  <td
                    style={{
                      border: '1px solid black',
                      padding: '4px 8px',
                      fontWeight: 400,
                    }}
                  >
                    {item[1]}
                  </td>
                </tr>
              )
          )}
        </tbody>
      </table>

      <br />
      <p>{value[value.length - 1]}</p>
    </>
  )
}

// 뭐가 뭔지 도저히 모르겠음1 - 채팅/결제 채팅인지 구분할 때 사용용
export const calculatePayment = (chat, order) => {
  const { product_name, price, cnslt_product } = chat

  let isPayment = Boolean(cnslt_product) && order.status !== 'cancel'

  if (isPayment) {
    const {
      user_name: name,
      date: reserve_day,
      time,
      people: person,
      option_lang: order_lang,
      email,
      rwg_info_id,
    } = chat

    // 추가해야할 파라미터
    // payment_gateway, card_price
    return {
      product_name,
      price,
      payment_information: {
        name,
        phone: '010',
        order_type: 'pmsfeepayment',
        reserve_day,
        reserve_time: time.slice(0, 5),
        person,
        order_lang,
        card_price: parseInt(price),
        kcp_price: 0,
        barogage_price: 0,
        redtable_price: 0,
        promotion_price: 0,
        email,
        s_channel: 'redtable',
        rwg_info_id,
        s_product_id: parseInt(chat.contents),
      },
    }
  } else return null
}

// 뭐가 뭔지 도저히 모르겠음2 - payment/deposit에서 오더 생성할때 사용
export const calculatePaymentChat = (chat, order) => {
  const { cnslt_product } = chat

  // 채팅상담에서 결제할때 쓸려고 만든건데 왜있는지는 모르겠음
  // let isPayment = Boolean(cnslt_product) && order.status !== 'cancel'
  let isPayment = true

  if (isPayment) {
    const {
      product_name,
      price,
      user_name: name,
      date: reserve_day,
      time,
      people: person,
      option_lang: order_lang,
      email,
      rwg_info_id,
      rwg_id,
      s_product_id,
      api_token,
    } = chat

    // 추가해야할 파라미터
    // payment_gateway, card_price
    return {
      product_name,
      price: parseInt(price),
      not_login_api_token: api_token,
      payment_information: {
        name,
        phone: '010',
        order_type: 'pmsfeepayment',
        reserve_day,
        reserve_time: time.toString().slice(0, 5),
        person: parseInt(person),
        order_lang,
        card_price: parseInt(price),
        kcp_price: 0,
        barogage_price: 0,
        redtable_price: 0,
        promotion_price: 0,
        email,
        s_channel: 'redtable',
        rwg_info_id: rwg_info_id ?? rwg_id,
        // product_id: parseInt(chat.contents), // 상담채팅에서 예약금 결제일때 사용
        s_product_id,
      },
    }
  } else return null
}

export const storeNameTranslate = (data) => {
  let obj = {}

  const langs = rwgLanguages.map((language) => language.key)
  langs.map((lang) => {
    const store_name = data.find((item) => item.lang === lang)?.name
    obj[lang] = store_name
  })

  return obj
}
